import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useSimilarProducts} from '../../SimilarProducts/hooks/useSimilarProducts';
import {useInlineSizeSelectionQuickViewAB} from '../AddToBasketQuickView/hooks/useInlineSizeSelectionQuickViewAB';
import {SimilarItemsQuickView} from './SimilarItemsQuickView';
import {SimilarProductsQuickViewLoading} from './SimilarProductsQuickViewLoading';
import {
  SimilarProductsQuickViewView,
  SimilarProductsQuickViewViewProps,
} from './SimilarProductsQuickViewView';

export const SimilarProductsQuickView = (
  props: SimilarProductsQuickViewViewProps & {ref?: React.Ref<HTMLElement>},
) => {
  const {ref} = props;
  const request = useSimilarProducts({disabled: !process.browser});
  const hasRecos = request.data?.recommendations.length;
  const isInlineSizeSelectionQuickViewAB = useInlineSizeSelectionQuickViewAB();

  return (
    <>
      <DataFetcher
        request={request}
        Error={null}
        Loading={SimilarProductsQuickViewLoading}
        viewProps={{...props, ref}}
        View={SimilarProductsQuickViewView}
      />

      {props.showScrollToSimilarItemsButton &&
      hasRecos &&
      !isInlineSizeSelectionQuickViewAB ? (
        <SimilarItemsQuickView similarProductsRef={ref as any} />
      ) : null}
    </>
  );
};
